module.exports = __webpack_public_path__ + "static/media/Delete2.61a2ac2d.svg";